import { render, staticRenderFns } from "./StatisticsAccessByTopic.vue?vue&type=template&id=4bf72cd0&"
import script from "./StatisticsAccessByTopic.vue?vue&type=script&lang=js&"
export * from "./StatisticsAccessByTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports